export default "__VITE_ASSET__f19f4bf7__"